import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { AddUsers, InvitedUsers } from '../components';
import { useAppDispatch, useAppSelector, useRedirectAndScroll } from '../../../hooks';
import styles from './styles.module.scss';
import { STEP_TWO_SNAPSHOT_KEY } from '../constants/constants';
import { setIsSave } from 'store/reducers/notifySlice';
import { CreateMemorialFooter } from '../CreateMemorialFooter';
import { isVac } from 'utilities/is-vac';
import { Helmet } from 'react-helmet-async';
import { Language } from 'providers/translates/enums';
import { useTranslates } from 'providers/translates';

interface CreateMemorialQuiltStepTwoProps {
  onSetIsStepOneUpdated?: () => void;
  isActiveStep: number;
  steps: {
    index: number;
    title: string;
  }[];
}

const translationsHelmet = {
  titleEN: 'Saluting Service - Create a quilt square - Step 2',
  titleFR: 'Saluons leur service - Créer un carreau de courtepointe - Étape 2'
} as const;

export const CreateMemorialQuiltStepTwo: React.FC<CreateMemorialQuiltStepTwoProps> = ({
  isActiveStep,
  steps,
  onSetIsStepOneUpdated
}) => {
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const location = useLocation();
  const editableQuilt = useAppSelector((state) => state.quilt.editableQuilt);
  const { redirectAndScroll } = useRedirectAndScroll({});
  const { translates: t } = useTranslates();
  const builderHeader = t?.quiltBuilder?.builderHeader;
  const invitationUI = t?.quiltBuilderStepTwo?.invitationUI;

  const continueAction = async () => {
    localStorage.removeItem(STEP_TWO_SNAPSHOT_KEY);
    redirectAndScroll(`${location.pathname}?step=3`);
  };
  const { selectedLang } = useTranslates();
  const isFrench = selectedLang === Language.FRENCH;

  useEffect(() => {
    onSetIsStepOneUpdated && onSetIsStepOneUpdated();
    dispatch(setIsSave(true));
  }, []);

  return (
    <>
    {isVac() && (
      <Helmet>
        <title>{isFrench ? translationsHelmet?.titleFR : translationsHelmet?.titleEN}</title>
      </Helmet>
    )}
    <div className="center">
      <div className={styles.title}>
        <span>
          {builderHeader?.introSubheading ?? 'Memorial quilt square for '}
        </span>
        <span>
          {editableQuilt?.firstName || ''} {editableQuilt?.lastName || ''}
        </span>
      </div>

      <div className={styles.inviteOther}>
        <h2 className="defaultTitle">
          {invitationUI?.inviteOthersHeading ?? 'Invite others to contribute '}          
        </h2>
        <p>
          {invitationUI?.invitationText ?? 'To invite others to contribute, add their email address below. Click the "+" to add additional email addresses. Invited contributors do not have to create an account. They will be sent a link to access the quilt square. They will be able to add text and photos and edit the quilt. If they save changes, the previous version cannot be recovered.'}
        </p>
      </div>

      {id ? (
        <Box className={styles.invitationForm}>
          <AddUsers
            pageName={(editableQuilt?.firstName && editableQuilt?.lastName) ? `${editableQuilt.firstName} ${editableQuilt.lastName}` : ''}
            id={id}
          />
        </Box>
      ) : (
        <></>
      )}

      <div className={styles.invitedUsers}>
        <Box>{id && <InvitedUsers idQuilt={id}></InvitedUsers>}</Box>
      </div>

      <CreateMemorialFooter
        isStepTwo
        onSave={continueAction}
        isActiveStep={isActiveStep}
        steps={steps}
      />
    </div>
    </>
  );
};
